<template>
  <div class="signals">
    <h4 class="title">Alerts:</h4>
    <div class="body">
      <div
        v-for="{ gamePeriod, over, odds, signalClass } in signals"
        :key="gamePeriod"
        class="signal"
        :class="signalClass"
      >
        <span class="game-period"
          >{{ gamePeriod == 1 ? "First Half Over" : "Total Over" }}
          {{ over }}</span
        >
        <span v-if="odds"> Odds: {{ odds }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignalsLive",
  props: {
    signals: {
      type: Array,
      required: false,
      default: () => [],
      validator(value) {
        return value.every(
          (item) =>
            typeof item.gamePeriod === "number" &&
            typeof item.over === "number" &&
            typeof item.signalClass === "string",
        );
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.signals {
  border-top: 1px solid var(--match-border-color);
  background-color: var(--league-body-color);
  padding: 5px 30px;
  /* Symmetric side columns keep the pills centered on the card,
     regardless of the title width */
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
}

.title {
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-self: start;
  font-size: 16px;
  padding-right: 30px;
  margin-bottom: 0;
  border-right: 2px solid var(--match-border-color);
  color: var(--font-color);
  font-weight: 500;
  text-wrap-mode: nowrap;
}

.body {
  /* Equal-width pills: the gap between them lands exactly on the card
     center line (the score divider) */
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 5px;
}

.signal {
  padding: 3px 50px;
  border-radius: 10px;
  text-align: center;
}

.game-period {
  padding-right: 10px;
}

.has-background-warning,
.has-background-success,
.has-background-danger {
  color: var(--back-color);
  fill: var(--back-color);
  stroke: var(--back-color);
}

.has-background-warning {
  background-color: var(--warning-background);
  border-bottom: none;
}

.has-background-success {
  background-color: var(--success-background);
  border-bottom: none;
}

.has-background-danger {
  background-color: var(--danger-background);
  border-bottom: none;
}

@media screen and (max-width: 768px) {
  .signal {
    padding: 3px 20px;
  }
}

@media screen and (max-width: 568px) {
  .title {
    padding-right: 15px;
  }

  .body {
    grid-auto-flow: row;
    padding: 0 20px;
  }

  .signal {
    padding: 3px 10px;
  }
}
</style>
